/** @jsxImportSource @emotion/react */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Confirm } from 'semantic-ui-react';
import { SimpleField } from '../../../shared/SimpleField';
import { DistributionListGroup } from '../models/distributionListGroup';
import style from './distributionListGroupCard.style';

interface DistributionListGroupCardReadOnlyProps {
  distributionListGroup: DistributionListGroup;
  onDelete: (id: string) => void;
  onEdit: () => void;
}

export const DistributionListGroupCardReadOnly = ({ distributionListGroup, onDelete, onEdit }: DistributionListGroupCardReadOnlyProps): JSX.Element => {
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <div css={style.card}>
        <div css={style.info}>
            <SimpleField
                value={distributionListGroup.name}
                title={t('distributionListGroups.distributionListGroupName')}
                icon='id badge'
            />
            <SimpleField
                value={distributionListGroup.brand.description}
                title={t('distributionListGroups.brand')}
                icon='copyright'
            />
        </div>
        <div css={style.distributionListGroup}>
            <SimpleField
                value={distributionListGroup.distributionList.map(contact => contact.email).join(', ')}
                title={t('distributionListGroups.distributionListGroup')}
                icon='group'
            />
        </div>
        <div css={style.info}>
          <SimpleField
            value={distributionListGroup.region.description}
            title={t('distributionListGroups.region')}
            icon='globe'
          />
          <SimpleField
            value={
              distributionListGroup.countries.length
                ? distributionListGroup.countries.map(country => country.description).join(', ')
                : t('distributionListGroups.allCountriesDescription').valueOf()
            }
            title={t('distributionListGroups.countries')}
            icon='globe'
          />
        </div>
      <div css={style.buttonsContainer}>
        <Button content={t('distributionListGroups.delete')} icon='trash' onClick={() => setConfirmOpen(true)} />
        <Button content={t('distributionListGroups.edit')} icon='edit' onClick={onEdit} />
        <Confirm
          open={confirmOpen}
          onCancel={() => setConfirmOpen(false)}
          onConfirm={() => onDelete(distributionListGroup.id)}
          size='mini'
        />
      </div>
    </div>
  );
};
